import { render } from "./ProposalThankYou.vue?vue&type=template&id=043f79d6&scoped=true"
import script from "./ProposalThankYou.vue?vue&type=script&lang=js"
export * from "./ProposalThankYou.vue?vue&type=script&lang=js"

import "./ProposalThankYou.vue?vue&type=style&index=0&id=043f79d6&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-043f79d6"]])

export default __exports__